export var textSizeXs = '1.2rem';
export var textSizeSm = '1.4rem';
export var textSizeMd = '1.6rem';
export var textSizeLg = '1.8rem';
export var textSizeXl = '2rem';
export var displaySizeXs = '2.4rem';
export var displaySizeSm = '3rem';
export var displaySizeMd = '3.6rem';
export var displaySizeLg = '4.8rem';
